<template>
  <BaseLayout page-default-back-link="/nativeTab/lawyer" pageTitle="法律服务详情" :showFooter="true">
    <ion-content class="legal-services">
      <img id="header" :src="headerImage" />
      <Tabs :data="tabsData" @change="tabsChange" />
      <img id="img-1" src="@/assets/jz/legalServices-1.png" />
      <img id="img-2" src="@/assets/jz/legalServices-2.png" />
      <img id="img-3" src="@/assets/jz/legalServices-3.png" />
      <img id="img-4" src="@/assets/jz/legalServices-4.png" />
      <img id="img-5" src="@/assets/jz/legalServices-5.png" />
      <img id="img-6" src="@/assets/jz/legalServices-6.png" />
      <img id="img-7" src="@/assets/jz/legalServices-7.png" />
      <img id="img-8" src="@/assets/jz/legalServices-8.png" />
      <img id="img-9" src="@/assets/jz/legalServices-9.png" />
      <img id="img-10" src="@/assets/jz/legalServices-10.png" />
      <img id="img-11" src="@/assets/jz/legalServices-11.png" />
      <img id="img-12" src="@/assets/jz/legalServices-12.png" />
      <img id="img-13" src="@/assets/jz/legalServices-13.png" />
      <img id="img-14" src="@/assets/jz/legalServices-14.png" />
      <img id="img-15" src="@/assets/jz/legalServices-15.png" />
      <div slot="fixed" class="to-header-btn" @click="toHeader">返回顶部</div>
    </ion-content>
  </BaseLayout>
</template>

<script>
import { ref, reactive } from 'vue'
import { DetailsListItem } from '@/view/lawyer/components'
import { serverUrl } from '@/utils/url'
import header1Image from '@/assets/jz/legal_products_header_1.png'
import header2Image from '@/assets/jz/legal_products_header_2.png'
import { useRoute } from 'vue-router'

export default {
  setup(props, { emit }) {
    const route = new useRoute()
    const tabsData = [
      {
        label: '产品介绍',
        value: 1,
      },
      {
        label: '民事起诉状',
        value: 2,
      },
      {
        label: '法院立案',
        value: 3,
      },
      {
        label: '诉讼文书送达',
        value: 4,
      },
      {
        label: '诉讼保全',
        value: 5,
      },
      {
        label: '诉讼举期限届满前法律审查',
        value: 6,
      },
      {
        label: '证据目录举证清单',
        value: 7,
      },
      {
        label: '证据交换与质证',
        value: 8,
      },
      {
        label: '回避申请',
        value: 9,
      },
      {
        label: '庭前通知',
        value: 10,
      },
      {
        label: '一审庭审',
        value: 11,
      },
      {
        label: '是否撤诉',
        value: 12,
      },
      {
        label: '律师代理词',
        value: 13,
      },
      {
        label: '裁判文书审查和送达模版',
        value: 14,
      },
      {
        label: '结案',
        value: 15,
      },
    ]
    const tabsChange = (item) => {
      document.getElementById(`img-${item.value}`).scrollIntoView()
    }
    const toHeader = () => {
      document.getElementById(`header`).scrollIntoView()
    }
    console.log('route', route.params.id == 1)
    const headerImage = route.params.id == 1 ? header1Image : header2Image
    return { tabsData, toHeader, tabsChange, headerImage }
  },
  components: { DetailsListItem },
}
</script>

<style lang="scss">
.legal-services {
  .to-header-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    // position: fixed;
    bottom: 120px;
    right: 40px;
    width: 140px;
    height: 60px;
    background-color: rgba(51, 112, 255, 0.6);
    color: #fff;
    border-radius: 8px;
  }
}
</style>